let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("klozw")).then(() => parcelRequire('kxY6j'));